
import { Component, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChatbotConfig, Project } from '@shared/index';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { ProjectNamePipe } from '../../../../../../../shared/pipes/project-name.pipe';
import { AdminService } from '@shared-angular/services/admin.service';
import { ProjectService } from '../../../../../../../shared/services/project.service';
import { LoginService } from '@shared-angular/services/login.service';

@Component({
  imports: [FormsModule, ProjectNamePipe, SelectModule, ButtonModule],
  templateUrl: './move-bot-to-project.component.html',
  styleUrl: './move-bot-to-project.component.scss'
})
export class MoveBotToProjectComponent implements OnInit {

  public bot!: ChatbotConfig;
  public projectId!: string;
  private readonly _projects = signal<Project[]>([]);
  public get projects(): Project[] { return this._projects(); }
  public set projects(value: Project[]) { this._projects.set(value); }

  constructor(
    private adminService: AdminService,
    private projectService: ProjectService,
    private modalRef: BsModalRef,
    public loginService: LoginService
  ) { }


  public async ngOnInit(): Promise<void> {
    await this.projectService.loadProjects();
    this.projects = this.projectService.projects;
  }


  public async moveToProject(projectId: string) {
    if (projectId === "-") {
      if (this.loginService.loggedInUser) {
        await this.adminService.updateBotField(this.bot._id, 'creatorName', this.loginService.loggedInUser.name);
        await this.adminService.updateBotField(this.bot._id, 'creator', this.loginService.loggedInUser._id);
        await this.adminService.updateBotField(this.bot._id, "projectId", null);
      }
    } else {
      await this.adminService.updateBotField(this.bot._id, "projectId", projectId);
    }
    await this.projectService.loadBots();
    this.modalRef.hide();
  }


}
